(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("buttongroup", [], factory);
	else if(typeof exports === 'object')
		exports["buttongroup"] = factory();
	else
		root["buttongroup"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 